// src/components/ui/MiniImagenProducto.js
// Miniatura de la foto de un producto para listas y resultados de búsqueda.
// Click en la foto abre el <ImagenLightbox> global SIN disparar el onClick de
// la fila contenedora (el wrapper corta la propagación): en los dropdowns de
// búsqueda la fila selecciona el producto y la foto solo amplía.
// Sin imagen → placeholder tokenizado. "Cambiar uno = cambiar todos."
//
// Uso:
//   <MiniImagenProducto url={prod.imagenUrl} nombre={prod.nombre} size={36} />
import React from 'react';
import ImagenEvidencia from './ImagenEvidencia';
import { CubeIcon } from './Icons';

function MiniImagenProducto({ url, nombre, size = 36 }) {
  if (!url) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: size, height: size, borderRadius: 6, background: 'var(--color-fondo)', border: '1px solid var(--color-borde-card)', color: 'var(--color-texto-secundario)', flexShrink: 0 }}>
        <CubeIcon className="w-4 h-4" />
      </span>
    );
  }
  return (
    <span onClick={(e) => e.stopPropagation()} style={{ display: 'inline-flex', flexShrink: 0 }}>
      <ImagenEvidencia url={url} nombre={nombre} size={size} radius={6} mensajeVencida="Imagen no disponible." />
    </span>
  );
}

export default MiniImagenProducto;
